import React, { useState } from "react";
import {
  TextField,
  Button,
  Typography,
  Divider,
  InputAdornment,
  IconButton,
  Box,
  CircularProgress,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import Notification from "../components/Common/Notification";

const Login: React.FC = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setLoading(true);
    setError(null);
    setSuccess(null);

    try {
      await login(username, password);
      setSuccess("Успешный вход в систему");
      const from = (location.state as any)?.from?.pathname || "/";
      setTimeout(() => {
        navigate(from, { replace: true });
      }, 1000);
    } catch {
      setError("Неверный логин или пароль");
    } finally {
      setLoading(false);
    }
  };

  const handleCloseNotification = () => {
    setError(null);
    setSuccess(null);
  };

  return (
    <Box sx={{ position: "relative" }}>
      <Typography variant="h5" gutterBottom>
        Вход в аккаунт
      </Typography>
      <Divider sx={{ mb: 3 }} />

      <Box component="form" onSubmit={handleSubmit} noValidate>
        <TextField
          label="Логин"
          variant="outlined"
          fullWidth
          margin="normal"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          required
          disabled={loading}
        />

        <TextField
          label="Пароль"
          variant="outlined"
          fullWidth
          margin="normal"
          type={showPassword ? "text" : "password"}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  edge="end"
                  onClick={() => setShowPassword((v) => !v)}
                  disabled={loading}
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
          required
          disabled={loading}
        />

        <Button
          type="submit"
          variant="contained"
          fullWidth
          sx={{ mt: 3, textTransform: "none", borderRadius: 2 }}
          disabled={loading}
        >
          {loading ? <CircularProgress size={24} /> : "Войти"}
        </Button>
      </Box>

      <Notification
        open={!!error}
        message={error || ""}
        severity="error"
        onClose={handleCloseNotification}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      />
      <Notification
        open={!!success}
        message={success || ""}
        severity="success"
        onClose={handleCloseNotification}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      />
    </Box>
  );
};

export default Login;
